import React from 'react';
import type { FC } from 'react';

export const NotFound: FC = () => <h1>404 - Not Found</h1>;
